module.exports = "<p>\n  text-item works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/text-item/text-item.component.html
// module id = ./src/app/reports/text-item/text-item.component.html
// module chunks = main